import { Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  removeLocalNotification,
  useNotificationDispatch,
  useNotificationState,
} from "../../Context";
import { classNames, getTypeIcon } from "../../Utils";

export const Notification = () => {
  const { t } = useTranslation();

  const notificationDispatch = useNotificationDispatch();
  const { localNotifications } = useNotificationState();

  function renderIcon(type = "info") {
    const iconType = type.toLowerCase();
    const Icon = getTypeIcon(iconType);
    switch (iconType) {
      case "warning":
        return <Icon className="w-6 h-6 text-yellow-400" aria-hidden="true" />;
      case "danger":
      case "error":
        return <Icon className="w-6 h-6 text-red-400" aria-hidden="true" />;
      case "success":
        return <Icon className="w-6 h-6 text-green-400" aria-hidden="true" />;
      default:
        return <Icon className="w-6 h-6 text-blue-400" aria-hidden="true" />;
    }
  }

  return (
    <div
      aria-live="assertive"
      className="z-50 fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
    >
      <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
        {localNotifications.map((notification) => {
          const type = notification.type || "info";
          return (
            <Transition
              key={notification.id}
              appear={true}
              show={true}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="p-4">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">{renderIcon(type)}</div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        {t(notification.title)}
                      </p>
                      <p
                        className={classNames(
                          notification.showFull ? "" : "truncate",
                          "mt-1 text-sm text-gray-500"
                        )}
                      >
                        {t(notification.body)}
                      </p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          removeLocalNotification(
                            notificationDispatch,
                            notification
                          );
                        }}
                      >
                        <span className="sr-only">{t("Close")}</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          );
        })}
      </div>
    </div>
  );
};
